import * as tracking from '../tracking';
import Util from '../forecast-app/shared/util/util';
import {commitMutation, graphql} from 'react-relay';

const mutation = graphql`
	mutation RetryUnit4LogItemMutation($input: RetryUnit4LogItemInput!) {
		retryUnit4LogItem(input: $input) {
			viewer {
				id
				unit4LogItems {
					id
					type
					person
					project
					workorder
					task
					date
					minutesRegistered
					notes
					errorMessage
				}
			}
			errors
		}
	}
`;

function commit(environment, input, onSuccess, onError) {
	tracking.trackEvent('Unit4 Logitem Retried');

	return commitMutation(environment, {
		mutation,
		variables: {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}},
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
